import React from 'react';

import { Icons } from '~/assets';

import { Container, Icon, Texto, Titulo } from './styles';

function NotFound() {
  return (
    <Container>
      <Icon src={Icons.NetworkOff} alt='sem rede' />

      <Titulo>Tivemos um problema de comunicação com o servidor.</Titulo>
      <Texto>
        Acesse o link novamente.
        <br />
        <br />
        Caso o problema persista por favor, entre em contato com a central de atendimento.
      </Texto>
    </Container>
  );
}

export default NotFound;
